import { getBaseUrlOrLocalhost } from './getBaseUrl'

export function getDocumentsUrl() {
	// always return the new document UI
    return `${getBaseUrlOrLocalhost()}documents`
}
